import { getUserLocalStorage } from "../context/AuthProvider/utils"
import { getHeaderItems } from "../services/header"


export function isLoginPage() {
    return window.location.pathname === '/'
}
